// extracted by mini-css-extract-plugin
export default {"startScreen":"StartScreen_startScreen__wV6Xu","startGameButton":"StartScreen_startGameButton__Oh6V9","guide":"StartScreen_guide__cRCPx","link":"StartScreen_link__7EX6i"};